import { render, staticRenderFns } from "./DefectiveList.vue?vue&type=template&id=95f3709c&scoped=true&"
import script from "./DefectiveList.vue?vue&type=script&lang=js&"
export * from "./DefectiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f3709c",
  null
  
)

export default component.exports